module.exports = __webpack_public_path__ + "static/media/main.31b75387.png";